import { render, staticRenderFns } from "./changePW.vue?vue&type=template&id=24991411"
import script from "./changePW.vue?vue&type=script&lang=js"
export * from "./changePW.vue?vue&type=script&lang=js"
import style0 from "./changePW.vue?vue&type=style&index=0&id=24991411&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports